export default __webpack_public_path__ + "static/media/doc2.36f362ad.jpeg";